import { useOutletContext } from "react-router"
import { AutomationRunsList } from "../../../../Automations/Runs"
import { TAutomation } from "../../../../Automations/store"
import { Helmet } from "react-helmet-async"

export default function AutomationRunsPage() {
	const context = useOutletContext<{
		automationId: string
		automation: TAutomation
	}>()

	return (
		<>
			<Helmet>
				<title>Runs | Automation Details</title>
			</Helmet>
			<AutomationRunsList
				automationIds={[Number(context.automationId)]}
				title="Runs"
				pageKey={`automation-${context.automationId}-runs`}
			/>
		</>
	)
}
